import type { Theme } from '@mui/material/styles';
import { useSidebar } from '@src/app/layout';
import { Box } from '@src/shared/ui/layout';
import { Outlet } from '@tanstack/react-router';
import { HeaderProvider } from './Header';

const StyleSheet = {
  main: ({ isCollapsed }: { isCollapsed: boolean }) => ({
    flexGrow: 1,
    marginTop: (t: Theme) => `${t.layout.header.height}px`,
    height: (t: Theme) => `calc(100% - ${t.layout.header.height}px)`,
    width: (t: Theme) =>
      `calc(100% - ${isCollapsed ? t.layout.sidebar.minWidth : t.layout.sidebar.maxWidth}px)`,
    backgroundColor: 'grey.150',
    overflow: 'auto',
    minHeight: '100vh',
    padding: '25px 20px 25px 10px',
    position: 'relative',
  }),
};

export default function Main() {
  const sidebar = useSidebar();

  if (!sidebar) {
    return null;
  }
  const { isCollapsed } = sidebar;
  return (
    <Box sx={StyleSheet.main({ isCollapsed })} component="main">
      <HeaderProvider>
        <Outlet />
      </HeaderProvider>
    </Box>
  );
}
